<template style="height: 100%;">
  <div class="User_personalinformation">
    <h2>基本信息</h2>
    <el-form :model="ruleForm"  ref="ruleForm"  label-width="100px" class="demo-ruleForm">

      <el-form-item label="学号:" prop="lpass">
        <el-input :disabled="true" v-model="ruleForm.UserID"></el-input>
      </el-form-item>

      <el-form-item label="姓名:" prop="newpass">
        <el-input v-model="ruleForm.RealName"></el-input>
      </el-form-item>

      <el-form-item label="单位名称:" prop="DeptID">
        <el-input :disabled="true" v-model="ruleForm.DeptID"></el-input>
      </el-form-item>

      <el-form-item label="身份证号:" prop="IDCard">
        <el-input v-model="ruleForm.IDCard"></el-input>
      </el-form-item>

      <el-form-item label="籍贯" prop="NativePlace">
        <el-select v-model="ruleForm.NativePlace" placeholder="请选择籍贯">
          <el-option v-for="item in value[3]" :key="item.DicID" :label="item.CDicValue" :value="item.DicKey"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="民族" prop="Nation">
        <el-select v-model="ruleForm.Nation" placeholder="请选择民族">
          <el-option v-for="item in value[1]" :key="item.DicKey" :label="item.CDicValue" :value="item.DicKey"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="性别" prop="Sex">
        <el-radio v-model="ruleForm.Sex" label="1">男</el-radio>
        <el-radio v-model="ruleForm.Sex" label="0">女</el-radio>
      </el-form-item>

      <el-form-item label="出生日期" prop="Birthday">
        <el-date-picker value-format="yyyy-MM-dd" v-model="ruleForm.Birthday" type="date" placeholder="选择日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="入学时间" prop="TheEntranceDate">
        <el-date-picker value-format="yyyy-MM-dd" v-model="ruleForm.TheEntranceDate" type="date" placeholder="选择日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="手机号" prop="Phone">
        <el-input v-model="ruleForm.Phone"></el-input>
      </el-form-item>

      <el-form-item label="身份证号" prop="IDCard">
        <el-input v-model="ruleForm.IDCard"></el-input>
      </el-form-item>

      <el-form-item label="户口类型" prop="AccountType">
        <el-radio v-model="ruleForm.AccountType" label="1">城市</el-radio>
        <el-radio v-model="ruleForm.AccountType" label="2">农村</el-radio>
      </el-form-item>
    </el-form>

    <el-button @click="save" :disabled="csbjb" style="margin-left: 49%;margin-bottom:20px;" type="primary">
      保存
    </el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: '',
      csbjb: false,
      ruleForm: {
        UserID: '',
        RealName: '',
        Sex: '',
        Birthday: '',
        Phone: '',
        IDCard: '',
        AccountType: '',
        DeptID: '',
        Nation: '',
        NativePlace: '',
        TheEntranceDate: '',
      },
    }
  },
  methods: {
    save() {
      this.csbjb = true;
      this.$Http_Post('User/UpdatePersonalData', this.ruleForm).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.csbjb = false;
          this.Global.request_successful(res.Message);
        } else {
          this.csbjb = false;
          this.Global.request_failure(res.Message);
        }
        this.loading(1, '');
      })
    },
  },
  mounted() {
    this.$Http_Post('User/PersonalData').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.ruleForm.UserID = res.Data.UserID;
        this.ruleForm.RealName = res.Data.RealName;
        this.ruleForm.Sex = res.Data.Sex;
        this.ruleForm.Birthday = res.Data.Birthday;
        this.ruleForm.Phone = res.Data.Phone;
        this.ruleForm.IDCard = res.Data.IDCard;
        this.ruleForm.AccountType = res.Data.AccountType;
        this.ruleForm.DeptID = res.Data.DeptNameJ;
        this.ruleForm.Nation = res.Data.Nation;
        this.ruleForm.NativePlace = res.Data.NativePlace;
        this.ruleForm.TheEntranceDate = res.Data.TheEntranceDate;
      }
    })

    this.$Http_Post('User/DictionaryList').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.value = res.Data;
      }
    })
  },
}
</script>
<style>
.User_personalinformation{height: 100%;overflow-y: auto;}
.User_personalinformation h2 {font-size: 24px;text-align: center;}
.User_personalinformation .demo-ruleForm {width: 500px;margin: auto;margin-top: 20px;}
.User_personalinformation .el-form-item {margin-top: 20px;}
.User_personalinformation .el-select {width: 100%;}
.User_personalinformation .el-date-editor { width: 100%;}
</style>
